import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { Shapes } from '../../models/entities';

class AutoComplete extends PureComponent {
  render() {
    const {
      options, labelKey, placeholder, defaultSelected, onChange, onSearch, disabled, isLoading, id,
    } = this.props;
    return (
      <AsyncTypeahead
        allowNew={false}
        multiple={false}
        minLength={3}
        options={options}
        onSearch={onSearch}
        onChange={onChange}
        placeholder={placeholder}
        labelKey={labelKey}
        disabled={disabled}
        defaultSelected={defaultSelected ? [defaultSelected] : []}
        isLoading={isLoading}
        id={id}
      />
    );
  }
}

AutoComplete.propTypes = {
  onSearch: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(Shapes.CLIENT),
  disabled: PropTypes.bool,
  labelKey: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  defaultSelected: Shapes.CLIENT,
  isLoading: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
};

AutoComplete.defaultProps = {
  options: [],
  disabled: false,
  defaultSelected: undefined,
};

export default AutoComplete;
